<template>
    <div>
        <v-row v-if="!isShortVersion"><v-col>Personal data</v-col></v-row>
        <v-row dense class="pb-0">
            <v-col cols="12" class="pr-2">
                <v-text-field :dense="isDense" :readonly="isReadOnly" v-model="guest.name" label="Name"></v-text-field>
            </v-col>
        </v-row>
        <v-row dense class="pb-0">
            <v-col cols="8" class="pr-2">
                <v-text-field :dense="isDense" :readonly="isReadOnly" v-model="guest.email" label="Email"></v-text-field>
            </v-col>
            <v-col cols="4" class="pr-2">
                <v-text-field :dense="isDense" :readonly="isReadOnly" v-model="guest.telephone" label="Telephone"></v-text-field>
            </v-col>
        </v-row>       
        <v-row dense class="pb-0">
            <v-col cols="12" class="pr-2" v-if="!isShortVersion">
                <v-text-field :dense="isDense" :readonly="isReadOnly" v-model="guest.address" label="Address"></v-text-field>
            </v-col>            
        </v-row>
        <v-row dense class="pb-0">    
            <v-col cols="12" class="pr-2" v-if="!isShortVersion">
                <v-text-field :dense="isDense" :readonly="isReadOnly" v-model="guest.city" label="City"></v-text-field>
            </v-col>                   
        </v-row>
    </div>
</template>

<script>
    export default {
        watch:{
            guest: {
                deep: true,
                handler(){
                    this.$emit('updateData', {field: 'guest', value: this.guest});
                } 
            },
        },        
        props:{
            guest: {
                type: Object,
                default: function() { return {name: '', email: '', telephone: '', address: '', city: ''}; },
            },
            isReadOnly: {
                type: Boolean,
                default: false
            },
            isDense: {
                type: Boolean,
                default: false
            },            
            isShortVersion:{
                type: Boolean,
                default: false
            },
            translatedLabels:{
                type: Array,
                default: function() { return []; },
            }            
        },
        data() {
            return {
            }
        },
        methods: {
        },
    };
</script>

<style scoped>

</style>